import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiFormControl: Components<Theme>['MuiFormControl'] = {
  defaultProps: {
    fullWidth: true,
    valid: false,
  },
  styleOverrides: {
    root: {
      variants: [
        {
          props: {
            valid: true,
          },
          style: {
            '&:hover fieldset, .Mui-focused fieldset, fieldset': {
              borderColor: `${scssVariables.ColorSuccess100} !important`,
            },
            '.MuiInputBase-root': {
              backgroundColor: `${scssVariables.ColorSuccess10} !important`,
            },
          },
        },
      ],

      ':has(.Mui-disabled)': {
        '.MuiInputBase-root, input': {
          cursor: 'not-allowed',
        },

        '.MuiInputBase-root': {
          backgroundColor: scssVariables.ColorBlack20,
        },
        input: {
          '-webkit-text-fill-color': scssVariables.ColorBlack60,
        },

        '.MuiInputAdornment-root': {
          // make color consistent with disabled input text
          color: scssVariables.ColorBlack60,
          '.MuiTypography-root': {
            color: scssVariables.ColorBlack60,
          },
        },

        '.MuiFormLabel-root': {
          color: scssVariables.ColorBlack80,
        },
      },

      '.MuiInputBase-root': {
        backgroundColor: scssVariables.ColorBlack00,
      },

      fieldset: {
        borderColor: scssVariables.ColorBlack40,
      },

      '&:hover:not(:has(.Mui-disabled)) fieldset': {
        borderColor: `${scssVariables.ColorBlue80} !important`,
      },

      '.Mui-focused': {
        '&.MuiInputBase-root:not(:has(.Mui-readOnly))': {
          backgroundColor: scssVariables.ColorBlue10,
        },

        '&.MuiFormLabel-root, &.MuiInputLabel-root': {
          color: scssVariables.ColorBlack80,
        },
        fieldset: {
          borderColor: `${scssVariables.ColorBlue80} !important`,
        },
      },

      '.Mui-error': {
        '&.MuiInputBase-root': {
          backgroundColor: scssVariables.ColorCoral10,
        },

        '&.MuiFormLabel-root, &.MuiInputLabel-root': {
          color: scssVariables.ColorBlack80,
        },
        fieldset: {
          borderColor: `${scssVariables.ColorCoral80} !important`,
        },
      },
    },
  },
};
